import baseApi from '../utils/ApiUtils';

export const deaccessionApi= (method, payload = null, params = null) => {
  return baseApi(`/deaccessions/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const deaccessionAction= (method, id, payload = null, params = null) => {
  return baseApi(`/deaccessions/${id}/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const deaccessionTaskPoolService= (method, id, payload = null, params = null) => {
  return baseApi(`/deaccessions/${id}/task_pools/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const deaccessionTransition= (method, id, payload = null, params = null) => {
  return baseApi(`/deaccessions/${id}/transition/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const deaccessionActivityLogService= (method, id, payload = null, params = null) => {
  return baseApi(`/deaccessions/${id}/activity_logs/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const deaccessionReportApi= (method, id, payload = null, params = null) => {
  return baseApi('reports/deaccessions/?format=csv', method, params, payload, 'blob').then(response => {
    return response.data;
  });
};